/** Compare two people (screenshots/46). */
export type RecordedVote = "yea" | "nay" | "absent" | "not_voting";

/** Agreement on divided roll calls where both actually voted (absences don't count either way). */
export function agreement(a: Record<string, RecordedVote>, b: Record<string, RecordedVote>) {
  let same = 0, both = 0;
  for (const id of Object.keys(a)) {
    const x = a[id], y = b[id];
    if ((x === "yea" || x === "nay") && (y === "yea" || y === "nay")) { both++; if (x === y) same++; }
  }
  return { same, both, pct: both ? Math.round((same / both) * 100) : null };
}

/** Topics where they split most: splits / shared votes per category, top N with at least 3 shared. */
export function splitsByTopic(a: Record<string, RecordedVote>, b: Record<string, RecordedVote>, category: Record<string, string>, top = 3) {
  const by = new Map<string, { split: number; of: number }>();
  for (const id of Object.keys(a)) {
    const x = a[id], y = b[id], c = category[id];
    if (!c || !(x === "yea" || x === "nay") || !(y === "yea" || y === "nay")) continue;
    const e = by.get(c) ?? { split: 0, of: 0 };
    e.of++; if (x !== y) e.split++;
    by.set(c, e);
  }
  return [...by.entries()].filter(([, e]) => e.of >= 3 && e.split > 0)
    .sort((p, q) => q[1].split / q[1].of - p[1].split / p[1].of).slice(0, top)
    .map(([topic, e]) => ({ topic, ...e }));
}

/** Leaning ranges overlap → "the difference isn't meaningful". */
export const rangesOverlap = (a: { low: number; high: number }, b: { low: number; high: number }) => a.low <= b.high && b.low <= a.high;

/** Shareable URL: /dashboard/people/compare?a=…&b=… (order-stable so links dedupe). */
export const compareHref = (a: string, b: string) => `/dashboard/people/compare?a=${encodeURIComponent(a)}&b=${encodeURIComponent(b)}`;
